export const listApplicationScreenshots = `
   query listApplicationScreenshots($filter: ApplicationScreenshotsFilterInput) {
       listApplicationScreenshots(filter: $filter) {
           items {
              id
              url
              path
              selector
              viewportWidth
              viewportHeight
              fullPage
              waitForSelector
              delay
              deviceScaleFactor
              hideScrollbars
              status
              screenshotUrl
              errorMessage
              fileSize
              created
              updated
           }
       }
   }
`;

export const getApplicationScreenshot = `
   query getApplicationScreenshot($id:ID!) {
       getApplicationScreenshot(id:$id) {
         id
         url
         path
         selector
         viewportWidth
         viewportHeight
         fullPage
         waitForSelector
         delay
         deviceScaleFactor
         hideScrollbars
         status
         screenshotUrl
         errorMessage
         fileSize
         createdByUsername
         created
         updated
       }
}`;
